// extracted by mini-css-extract-plugin
export default {"bg":"ThfRMqwq"};